export interface ITableCell {
    property: string;
    title?: string;
    sortable?: boolean;
    filter?: string;
    filterType?: string;
    additionalClasses?: string;
    showTitle?: boolean;
    getTitle?(): string;
}
